const CID_MACRO = 'cid=@@CID@@';
const CID_PARAM_PATTERN = /cid=/i;

export function requiresCidMacro(url: string | undefined): boolean {
	if (!url) {
		return false;
	}
	return url.includes(CID_MACRO);
}

export function hasForbiddenCid(url: string | undefined): boolean {
	if (!url) {
		return false;
	}
	return CID_PARAM_PATTERN.test(url);
}

export function validateDestUrlForAccount(destUrl: string | undefined, useInternalPricing: boolean | undefined): string | null {
	if (!destUrl?.trim()) {
		return 'Please provide a destination URL';
	}

	if (useInternalPricing) {
		if (!requiresCidMacro(destUrl)) {
			return 'Destination URL must contain cid=@@CCID@@';
		}
		return null;
	}

	if (hasForbiddenCid(destUrl)) {
		return 'Destination URL must not contain a cid parameter';
	}

	return null;
}
